import { queryOptions, useQuery } from "@tanstack/react-query"
import type { ShelfTypeOrderEntry } from "@/features/shelf-type-order/core/shelfTypeOrderSchema"
import { getShelfTypeOrderFn } from "@/features/shelf-type-order/server/shelfTypeOrderServer"
import { shelfTypeOrderQueryKeys } from "@/lib/queryKeys"

export const shelfTypeOrderQuery = () =>
  queryOptions({
    queryKey: shelfTypeOrderQueryKeys.list(),
    queryFn: () => getShelfTypeOrderFn(),
    staleTime: 5 * 60 * 1000,
  })

export function useShelfTypeOrder(): ShelfTypeOrderEntry[] {
  const { data } = useQuery(shelfTypeOrderQuery())
  return data ?? []
}
